import builder from '../builder';
import Bin2 from '../../streamline-icons/light/bin-2.svg';

export default builder('IconBin2Light', Bin2);
